// extracted by mini-css-extract-plugin
module.exports = {"container":"DevTools_container__y_H-f","info":"DevTools_info__Q55GO","languageSelection":"DevTools_languageSelection__29vHQ"};